import { invokeApi } from '../bl_libs/invokeApi';
import { use_e2ee } from '../utils/utils';
import { LOCAL_STORAGE_KEYS } from '../utils/constants';

const getToken = () => JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));

/**
 * Features the insider's package marks "available", each with an `is_active` flag.
 * Response: { data: { features: [{ feature_key, label, description, is_active }] } }
 */
export const getAvailableFeaturesService = () => {
    return invokeApi({
        path: '/dq_insider/features/available',
        method: 'GET',
        headers: { Authorization: `Bearer ${getToken()}` },
    }, use_e2ee());
};

/**
 * The insider's currently active feature activations.
 */
export const getActiveFeaturesService = () => {
    return invokeApi({
        path: '/dq_insider/features/active',
        method: 'GET',
        headers: { Authorization: `Bearer ${getToken()}` },
    }, use_e2ee());
};

/**
 * Self-activate an available feature.
 */
export const activateFeatureService = (feature_key) => {
    return invokeApi({
        path: '/dq_insider/features/activate',
        method: 'POST',
        headers: { Authorization: `Bearer ${getToken()}` },
        postData: { feature_key },
    }, use_e2ee());
};

/**
 * Deactivate a self-activated feature.
 */
export const deactivateFeatureService = (feature_key) => {
    return invokeApi({
        path: '/dq_insider/features/deactivate',
        method: 'POST',
        headers: { Authorization: `Bearer ${getToken()}` },
        postData: { feature_key },
    }, use_e2ee());
};
